import clsx from 'clsx';
import Image from 'next/image';
import Robot01Src from '@/assets/robot-01.png';
import Parroto1PointingSrc from '@/assets/parrot_01_pointing.png';
import Parrot02DeskSrc from '@/assets/parrot_02_desk.png';
import Parrot03SpeakingSrc from '@/assets/parrot_03_speaking.png';
import Parrot04ReadingSrc from '@/assets/parrot_04_reading.png';
import Parrot05LearningSrc from '@/assets/parrot_05_learning.png';
import Parrot06TeacherSrc from '@/assets/parrot_06_teacher.png';
import Parrot07FlyingSrc from '@/assets/parrot_07_flying.png';
import Parrot08ThinkingSrc from '@/assets/parrot_08_thinking.png';
import Parrot09ThinkingSrc from '@/assets/parrot_09_tablet.png';
import Parrot10ThinkingSrc from '@/assets/parrot_10_tablet_chair.png';
import Parrot11SquawkingSrc from '@/assets/parrot_11_squawking.png';

export type ParrotType =
  | 'robot'
  | 'pointing'
  | 'desk'
  | 'speaking'
  | 'reading'
  | 'learning'
  | 'teacher'
  | 'flying'
  | 'thinking'
  | 'tablet'
  | 'tablet-chair'
  | 'squawking';

interface ParrotProps {
  className?: string;
  type?: ParrotType;
  content?: React.ReactNode;
}

export const Parrot = ({ className, type = 'desk', content }: ParrotProps) => {
  const getImage = () => {
    switch (type) {
      case 'robot':
        return (
          <Image
            src={Robot01Src}
            alt="Pickatale Robot"
            width={Robot01Src.width}
            height={Robot01Src.height}
            className={className}
          />
        );

      case 'pointing':
        return (
          <Image
            src={Parroto1PointingSrc}
            alt="Pickatale Parrot Pointing"
            width={Parroto1PointingSrc.width}
            height={Parroto1PointingSrc.height}
            className={className}
          />
        );

      case 'desk':
        return (
          <Image
            src={Parrot02DeskSrc}
            alt="Pickatale Parrot at a desk"
            width={Parrot02DeskSrc.width}
            height={Parrot02DeskSrc.height}
            className={className}
          />
        );

      case 'speaking':
        return (
          <div className={clsx('relative', className)}>
            <Image
              src={Parrot03SpeakingSrc}
              alt="Pickatale Parrot saying something"
              width={Parrot03SpeakingSrc.width}
              height={Parrot03SpeakingSrc.height}
              className="w-full h-auto"
            />
            {content && (
              <div className="absolute top-0 left-0 w-full">
                <div className="mt-[5%] mr-[5%] ml-[20%] text-lg text-green-dark">
                  {content}
                </div>
              </div>
            )}
          </div>
        );

      case 'reading':
        return (
          <Image
            src={Parrot04ReadingSrc}
            alt="Pickatale Parrot reading in a chair"
            width={Parrot04ReadingSrc.width}
            height={Parrot04ReadingSrc.height}
            className={className}
          />
        );

      case 'learning':
        return (
          <Image
            src={Parrot05LearningSrc}
            alt="Pickatale Parrot at as desk"
            width={Parrot05LearningSrc.width}
            height={Parrot04ReadingSrc.height}
            className={className}
          />
        );

      case 'teacher':
        return (
          <Image
            src={Parrot06TeacherSrc}
            alt="Pickatale Parrot as a teacher"
            width={Parrot06TeacherSrc.width}
            height={Parrot06TeacherSrc.height}
            className={className}
          />
        );

      case 'flying':
        return (
          <Image
            src={Parrot07FlyingSrc}
            alt="Pickatale Parrot Flying"
            width={Parrot06TeacherSrc.width}
            height={Parrot06TeacherSrc.height}
            className={className}
          />
        );

      case 'thinking':
        return (
          <Image
            src={Parrot08ThinkingSrc}
            alt="Pickatale Parrot Thinking"
            width={Parrot08ThinkingSrc.width}
            height={Parrot08ThinkingSrc.height}
            className={className}
          />
        );

      case 'tablet':
        return (
          <Image
            src={Parrot09ThinkingSrc}
            alt="Pickatale Parrot with a tablet"
            width={Parrot09ThinkingSrc.width}
            height={Parrot09ThinkingSrc.height}
            className={className}
          />
        );

      case 'tablet-chair':
        return (
          <Image
            src={Parrot10ThinkingSrc}
            alt="Pickatale Parrot with a tablet and chair"
            width={Parrot10ThinkingSrc.width}
            height={Parrot10ThinkingSrc.height}
            className={className}
          />
        );

      case 'squawking':
        return (
          <Image
            src={Parrot11SquawkingSrc}
            alt="Pickatale Parrot Squawking"
            width={Parrot11SquawkingSrc.width}
            height={Parrot11SquawkingSrc.height}
            className={className}
          />
        );
    }
  };

  return getImage();
};
